import * as React from "react";
import {
  BottomSwoosh,
  Container,
  Title,
  Wrapper,
  BannerWrapper,
  Description,
  TitleSection,
  LoadingWrapper,
  EmptyStateWrapper,
  InnerContainer,
  SliderContainer,
} from "./GallerySection.styled";
import Tabs from "../../../atoms/Tabs/Tabs";
import CardKota from "../../../atoms/CardKota";
import {
  useBulkFetchEventSeries,
  useBulkFetchGallerySeries,
  useFetchEventSeries,
  useFetchEventSeriesDetail,
  useFetchMainRegionGallery,
} from "../../../../networks/resolvers";
import useDebounce from "../../../../hooks/useDebounce";
import Skeleton from "react-loading-skeleton";
import { ReactComponent as EmptyState } from "./assets/empty-state.svg";
import { ReactComponent as EmptyStateDesktop } from "./assets/empty-state-desktop.svg";
import SliderWrapper from "../../../atoms/SliderWrapper";
import useWindowSize from "../../../../hooks/useWindowSize";
import moment from "moment";
import { getStaticImg } from "../../../../utils/function";
import { useNavigate } from "react-router-dom";
import { func } from "../../../../utils";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const GallerySection = () => {
  const [slug, setSlug] = React.useState();
  const navigate = useNavigate();
  const [isChangeTab, setIsChangeTab] = React.useState(false);

  const { size } = useWindowSize();

  const isMobile = size?.width <= 768;

  const { data: dataEventRaw, isFetching: fetchingEventSeries } =
    useFetchEventSeries();

  const dataEventSeries =
    dataEventRaw?.data?.data?.eventSeries?.filter(
      (val) => val?.slug !== "soc"
    ) ?? [];

  const dataEventSeriesActiveTab = React.useMemo(() => {
    const sortFromStartDate = [...dataEventSeries]?.sort((a, b) =>
      a?.event_start_date > b?.event_start_date ? 1 : -1
    );

    const addIsPassEventData = [...sortFromStartDate]?.map((data) => {
      const currentDate = moment().format("YYYY-MM-DD");

      return {
        ...data,
        isPassEvent: moment(currentDate)?.isAfter(data?.event_end_date),
      };
    });

    const passEventData = addIsPassEventData?.filter(
      (data) => data?.isPassEvent
    );
    const dataEvent = addIsPassEventData?.filter((data) => !data?.isPassEvent);

    return [...dataEvent, ...passEventData];
  }, [dataEventSeries]);

  const dataMainRegion = React.useMemo(() => {
    if (!dataEventSeriesActiveTab) return {};
    return dataEventSeriesActiveTab?.map((data, idx) => ({
      id: idx,
      title: data?.main_region_name,
      slug: data?.slug,
    }));
  }, [dataEventSeriesActiveTab]);

  const {
    data: dataEventSeriesDetailRaw,
    isFetching: fetchingEventSeriesDetail,
  } = useFetchEventSeriesDetail(
    slug ?? dataMainRegion?.[0]?.slug,
    !isChangeTab && !fetchingEventSeries
  );

  const { isLoading: loadingEventSeriesBulk, data: dataEventSeriesBulkRaw } =
    useBulkFetchEventSeries(dataMainRegion?.map((val) => val?.slug));

  const { data: dataMainRegionGallery, isFetching: fetchingMainRegionGallery } =
    useFetchMainRegionGallery(moment().year());
  const sortByStartDateAscending = (data) => {
    if (Array.isArray(data)) {
      return data?.sort(
        (a, b) => new Date(a.event_start_date) - new Date(b.event_start_date)
      );
    }
  };

  const slugDataMainRegionGallery = sortByStartDateAscending(
    dataMainRegionGallery?.data?.data
  )?.map((val) => val?.slug);
  const { isLoading: loadingBulkGallery, data: dataBulkGallery } =
    useBulkFetchGallerySeries(
      slugDataMainRegionGallery?.map((val) => {
        return {
          year: moment().year(),
          main_region: val,
        };
      })
    );

  const dataEventSeriesDetail =
    dataEventSeriesDetailRaw?.data?.data?.eventSeries?.[0];

  const isLoading = loadingEventSeriesBulk;

  const filterDataBySlug = (origin, target) => {
    // Create an array of slugs from target
    if (Array.isArray(target)) {
      const slugsTarget = target.map((item) => item.slug);

      const filteredOrigin = origin.filter((item) =>
        slugsTarget.includes(item.slug)
      );

      return filteredOrigin;
    }
  };

  const handleChangeTab = (data) => {
    setIsChangeTab(true);
    setSlug(data?.slug);
  };

  const handleOnClick = (data) => {
    setIsChangeTab(false);
    setSlug(data?.slug);
  };

  const handleGoToGalleryDetail = (slug) => {
    if (!slug) return navigate("/gallery");

    navigate("/gallery", {
      state: {
        slug,
      },
    });
  };

  useDebounce(
    () => {
      if (slug && isChangeTab) {
        setIsChangeTab(false);
      }
    },
    600,
    [slug]
  );
  const dataEventSeriesBulk = filterDataBySlug(
    dataEventSeriesBulkRaw,
    dataMainRegionGallery?.data?.data
  );
  const isShowCityCard = dataEventSeriesBulk?.length > 0;

  const Card = ({ cardWidth, onClick, data = {}, index }) => {
    const otherData = {
      key_visual_gallery: func.getStaticImg(
        "/illustration/default-gallery.png"
      ),
      main_region_name: "-",
      slug: "",
      region_series: [],
    };
    const mainData = data === "default" ? otherData : data;
    const regionName = mainData?.main_region_name ?? "-";
    const regionSlug = mainData?.slug ?? "";
    const regionSeries = mainData?.region_series ?? [];
    const labelBtn = data === "default" ? "Series Lainnya" : "Lihat Series";
    const bgPosition = data === "default" ? "50% 40%" : "50%";
    const bgSize = data === "default" ? "60%" : "cover";
    const bgLength =
      data === "default"
        ? "!bg-[length:auto_60%] hover:!bg-[length:auto_75%]"
        : "!bg-[length:auto_100%] hover:!bg-[length:auto_115%]";
    const keyVisual =
      data === "default"
        ? mainData?.key_visual_gallery
        : imgPath + encodeURI(mainData?.key_visual_gallery);
    const bgColor = data === "default" ? "#1F2D3D" : "lightgray";
    const bgGradient =
      data === "default"
        ? ""
        : "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 42.72%, rgba(0, 0, 0, 0.50) 71.31%, rgba(0, 0, 0, 0.90) 99.95%),";

    return (
      <div
        className={`group min-h-[508px] md:min-w-[312px] min-w-[250px] w-[${cardWidth}px] flex items-end rounded-2xl cursor-pointer transition ease-in-out delay-150  hover:scale-101 duration-300 ${bgLength}`}
        style={{
          background: `${bgGradient} url(${keyVisual}) ${bgColor} ${bgPosition} / ${bgSize} no-repeat`,
          transition: "background-size 0.5s ease-in",
        }}
        onClick={onClick}
      >
        <div className="p-6 w-full">
          {data !== "default" && (
            <div className="flex flex-col">
              <span className="text-[20px] uppercase font-semibold text-white">
                {regionName}
              </span>
              <span className="text-[12px] text-white">
                {dataBulkGallery?.[index]?.length} Kota
              </span>
              <div className="flex gap-2 flex-wrap mt-3">
                {dataBulkGallery[index]?.map((series, indexSeries) => {
                  const cityName = series?.region_name;
                  return (
                    <div
                      key={indexSeries}
                      className="rounded-[4px] bg-white 1 w-min"
                    >
                      <span className="text-[11px] font-semibold m-0 py-[2px] px-[6px] capitalize">
                        {cityName}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div
            onClick={() => handleGoToGalleryDetail(regionSlug)}
            className="mt-4 rounded-[40px] border-solid border-2 border-white py-3 px-4 flex justify-center group-hover:bg-[#00BCF1]"
          >
            <span className="text-white font-semibold">{labelBtn}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container id="gallery">
      <InnerContainer>
        <Wrapper className="md:mt-0 mt-[16px]">
          {isLoading ? (
            <>
              <LoadingWrapper>
                <Skeleton width="100%" height={168} borderRadius={16} />
              </LoadingWrapper>
              <LoadingWrapper>
                <Skeleton width="100%" height={20} borderRadius={16} />
              </LoadingWrapper>
              <LoadingWrapper>
                <Skeleton width="20%" height={20} borderRadius={16} />
              </LoadingWrapper>
              <SliderWrapper showItems={3} totalData={5}>
                {() => (
                  <>
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                    <Skeleton width="157px" height={160} borderRadius={16} />
                  </>
                )}
              </SliderWrapper>
            </>
          ) : (
            <>
              {dataEventSeriesBulk?.length > 0 ? (
                <div className="flex flex-row md:pl-6 mb-[16px] md:w-[calc(100%_+_45px)] md:mb-[25px]">
                  <span className="md:text-[32px] text-[20px] text-white font-semibold md:ml-[32px] ml-0">
                    Galeri Piala by.U
                  </span>
                  <div
                    className="ml-auto cursor-pointer"
                    onClick={() => navigate("/gallery")}
                  >
                    <span className="md:text-[16px] text-[14px] text-white cursor-pointer">
                      Lihat semua
                    </span>
                    <img
                      src={getStaticImg("/illustration/sa-arrow-right.svg")}
                      alt="arrow-right"
                      style={{ marginLeft: 4 }}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <EmptyStateWrapper>
                    {isMobile ? <EmptyState /> : <EmptyStateDesktop />}
                  </EmptyStateWrapper>
                  <Description style={{ textAlign: "center" }}>
                    Segera!!! Akan hadir di Kotamu Piala by.U 2024, jangan
                    sampai kelewatan!
                  </Description>
                </>
              )}
            </>
          )}
        </Wrapper>
        <SliderContainer>
          {!isLoading && isShowCityCard && (
            <SliderWrapper
              isDarkMode
              showDotsIndicator={isMobile ? false : true}
              showItems={3}
              showArrow={dataEventSeriesBulk?.length > 3}
              step={1}
              style={
                !isMobile
                  ? {
                      width: dataEventSeriesBulk?.length > 3 ? "100%" : "978px",
                    }
                  : {}
              }
              cardWrapperStyle={!isMobile ? { width: "100%" } : {}}
              totalData={dataEventSeriesBulk?.length + 1 ?? 0}
              swipeable={false}
              columnGap={isMobile ? "16" : "64"}
            >
              {({ cardWidth }) => {
                return (
                  <>
                    {[...dataEventSeriesBulk, "default"]?.map((data, idx) => (
                      <Card
                        key={idx}
                        index={idx}
                        data={data}
                        cardWidth={`${cardWidth}px`}
                        onClick={() => {}}
                      />
                    ))}
                  </>
                );
              }}
            </SliderWrapper>
          )}
        </SliderContainer>
      </InnerContainer>
    </Container>
  );
};

export default GallerySection;
